<template>
  <div class="user">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name: '个人中心'}]"></breadcrumb>
    <div class="user-main">
      <div class="user-form_wrap">
        <div class="user-form_header">
          <img :src="userForm.networkHeadUrl">
          <input class="user-photo_input"
                 type="file"
                 accept="image/png, image/jpeg, image/gif, image/jpg"
                 @change="selectPhoto">
        </div>
        <div class="user-form_contain">
          <el-form :model="userForm"
                   :rules="rules">
            <el-row :gutter="5">
              <el-col :span="8">
                <div class="user-form_label">姓名</div>
                <el-form-item prop="name">
                  <el-input class="user-form_input"
                            v-model="userForm.name"
                            placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="user-form_label">部门</div>
                <el-form-item prop="departmentId">
                  <el-select class="user-form_input"
                             v-model="userForm.departmentId"
                             placeholder="请选择">
                    <el-option v-for="item in departmentList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="user-form_label">职务</div>
                <el-form-item prop="postJobId">
                  <el-select class="user-form_input"
                             v-model="userForm.postJobId"
                             placeholder="请选择">
                    <el-option v-for="item in jobList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="8">
                <div class="user-form_label">手机号</div>
                <el-form-item prop="phone">
                  <el-input class="user-form_input"
                            v-model="userForm.phone"
                            type="tel"
                            placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="user-form_label"
                     type="email">Email</div>
                <el-form-item prop="email">
                  <el-input class="user-form_input"
                            v-model="userForm.email"
                            placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="user-form_label">所属</div>
                <el-form-item prop="representOfficeId">
                  <div class="user-form_div">
                    <span>{{userForm.representOfficeName}}</span>
                    <el-tooltip effect="light"
                                placement="bottom">
                      <div class="user-tooltip"
                           slot="content">
                        <div class="user-tooltip_title">包含省份:</div>
                        <div class="user-areaList">
                          <div class="user-areaItem"
                               v-for="item in areaList"
                               :key="item.id">{{item.name}}</div>
                        </div>
                      </div>
                      <font-awesome-icon style="cursor:pointer"
                                         :icon="['fas', 'ellipsis-h']" />
                    </el-tooltip>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <div class="user-form_label">
                <span>个人签名</span>
                <span @click="reUpload"
                      v-if="userForm.personalSignatureUrl"
                      class="user-redo">
                  <font-awesome-icon class="user-redo_icon"
                                     :icon="['fas', 'redo']" />重新上传
                </span>
              </div>
              <div class="user-form_sign">
                <div v-show="!userForm.personalSignatureUrl"
                     class="user-no_sign">
                  <el-button class="user-sign_button"
                             type="primary">
                    <input ref="input"
                           class="user-sign_input"
                           type="file"
                           accept="image/png, image/jpeg, image/gif, image/jpg"
                           @change="selectSign">
                    <font-awesome-icon class="user-upload_icon"
                                       :icon="['fas', 'upload']" />上传签名
                  </el-button>
                  <div>请上传JPG、PNG格式的图片，建议白色背景黑色签名，图片宽高300*100像素效果最佳</div>
                </div>
                <img v-show="userForm.personalSignatureUrl"
                     class="user-sign_img"
                     :src="userForm.personalSignatureUrl">
              </div>
            </el-row>
            <div>
              <el-button class="user-form_submit"
                         @click="changePaw">修改密码</el-button>
            </div>
            <div>
              <el-button type="primary"
                         class="user-form_submit"
                         @click="submit()">提交</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog class="user-dialog"
     :close-on-click-modal="false"
               title="修改密码"
               :visible.sync="dialogFormVisible">
      <el-form :model="pwdForm"
               ref="pwdForm"
               :rules="pwdRules">
        <el-form-item prop="oldPwd">
          <el-input type="password"
                    autocomplete="off"
                    v-model="pwdForm.oldPwd"
                    placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item prop="newPwd">
          <el-input type="password"
                    autocomplete="off"
                    v-model="pwdForm.newPwd"
                    placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item prop="newPwd2">
          <el-input type="password"
                    autocomplete="off"
                    v-model="pwdForm.newPwd2"
                    placeholder="再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="passwordSubmit('pwdForm')">提 交</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import axios from '@/servies/axios'
import api from '@/servies/api'
export default {
  components: {
    breadcrumb
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if(!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,12}$/.test(value)){
          callback(new Error('请输入8-12位，包含大小写英文和数字的密码'))

        }
        else if (this.pwdForm.newPwd2 !== '') {
          this.$refs.pwdForm.validateField('newPwd2')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.pwdForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      userForm: {
        id: '',
        name: '',
        departmentId: '',
        postJobId: '',
        phone: '',
        email: '',
        roleId: '',
        representOfficeId: '',
        representOfficeName: '',
        networkHeadUrl: '',
        personalSignatureUrl: ''
      },
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      },
      areaList: [],
      rules: {
        name: [{ required: true, message: '姓名不可为空' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      pwdRules: {
        oldPwd: [{ required: true, message: '旧密码不可为空' }],
        newPwd: [{ validator: validatePass, trigger: 'blur' }],
        newPwd2: [{ validator: validatePass2, trigger: 'blur' }]
      },
      departmentList: [],
      jobList: [],
      officeList: [],
      dialogFormVisible: false
    }
  },
  mounted() {
    this.initList()
    this.getUserDetail()
  },
  methods: {
    //获取下拉的列表
    initList() {
      //获取部门列表
      axios
        .get(api.departList)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取部门列表成功', res.data.result)
            this.departmentList = res.data.result
          } else {
            console.log('获取部门列表失败', res.data.msg)
          }
        })
        .catch(error => {
          console.log('获取部门列表失败', error)
        })
      //获取职务列表
      axios
        .get(api.postJobList)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取职务列表成功', res.data.result)
            this.jobList = res.data.result
          } else {
            console.log('获取职务列表失败', res.data.msg)
          }
        })
        .catch(error => {
          console.log('获取职务列表失败', error)
        })
      //获取代表处
      axios
        .get(api.officeList)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取代表处列表成功', res.data.result)
            this.officeList = res.data.result
          } else {
            console.log('获取代表处列表失败', res.data.msg)
          }
        })
        .catch(error => {
          console.log('获取代表处列表失败', error)
        })
    },
    //获取个人信息
    getUserDetail() {
      axios
        .get(api.userDetail)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取个人信息成功', res.data.result)
            this.areaList = res.data.result.areaList
            this.userForm = res.data.result.user
          } else {
            console.log('获取个人信息失败', res.data.msg)
          }
        })
        .catch(error => {
          console.log('获取个人信息失败', error)
        })
    },
    // 提交个人信息
    submit() {
      axios.post(api.commonUserUpdate, this.userForm)        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: "修改个人信息成功",
              type: "success"
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        });
    },
    //修改密码
    passwordSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          axios
            .post(
              api.modifyPwd +
                `?oldPwd=${this.pwdForm.oldPwd}&newPwd=${this.pwdForm.newPwd}`
            )
            .then(res => {
              if (res.data.code === 0) {
                this.$message({
                  message: '修改密码成功',
                  type: 'success'
                })
                this.dialogFormVisible = false
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(error => {
              this.$message.error('网络错误，稍后重试')
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 选择头像
    async selectPhoto(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      await this.uploadImage(files[0], 'photo')
    },
    //上传图片
    uploadImage(file, type) {
      let param = new FormData()
      param.append('file', file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      let url = type === 'photo' ? api.uploadNetworkHead : api.uploadSignPic
      return axios
        .post(url, param, config)
        .then(res => {
          if (res.data.code === 0) {
             this.$message({
              message: "上传图片成功",
              type: "success"
            });
            this.getUserDetail()
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，稍后重试");
        })
    },
    // 选择签名
    async selectSign(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.userForm.personalSignatureUrl = await this.uploadImage(
        files[0],
        'sign'
      )
    },
    // 重新上传
    reUpload() {
      this.$refs.input.click()
    },
    //修改密码
    changePaw(){
       this.pwdForm={
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      }
            this.dialogFormVisible = true
    }
  }
}
</script>

<style lang="scss">
.user {
  .user-main {
    width: 100%;
    display: flex;
    justify-content: center;
    .user-form_wrap {
      margin-top: 130px;
      width: 760px;
      background: #fff;
      .user-form_header {
        position: relative;
        height: 74px;
        background: linear-gradient(
          180deg,
          rgba(249, 171, 86, 1) 0%,
          rgba(240, 114, 43, 1) 100%
        );
        border-radius: 4px 4px 0px 0px;
        border: 1px solid rgba(230, 227, 227, 1);
        img {
          cursor: pointer;
          position: absolute;
          top: -50px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 100px;
          object-fit: contain;
          border-radius: 100px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 0px 5px rgba(255, 255, 255, 0.43);
        }
        .user-photo_input {
          position: absolute;
          top: -50px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 100px;
          border-radius: 100px;
          opacity: 0;
        }
      }
      .user-form_contain {
        padding: 45px 45px 41px 45px;
        .el-row {
          &:first-child {
            margin-bottom: 39px;
          }
          &:nth-child(2) {
            margin-bottom: 32px;
          }
        }
        .user-form_label {
          font-size: 16px;
          color: #4a4a4a;
          line-height: 24px;
          padding-bottom: 11px;
          .user-redo {
            color: #9b9b9b;
            font-size: 14px;
            cursor: pointer;
            float: right;
            position: relative;
            bottom: -2px;
            .user-redo_icon {
              margin-right: 3px;
            }
          }
        }
        .user-form_input {
          max-width: 200px;
        }
        .user-form_div {
          border: 1px solid #dcdfe6;
          max-width: 200px;
          height: 40px;
          border-radius: 4px;
          padding: 0 15px;
          box-sizing: border-box;
          color: #9b9b9b;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .user-form_sign {
          border: 1px #dcdfe6 solid;
          border-radius: 4px;
          height: 140px;
          font-size: 14px;
          color: #9b9b9b;
          .user-no_sign {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            .user-sign_button {
              position: relative;
              margin-bottom: 16px;
              .user-sign_input {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
              }
              .user-upload_icon {
                margin-right: 3px;
              }
            }
          }
          .user-sign_img {
            height: 100%;
            width: 100%;
            object-fit: contain;
            cursor: pointer;
          }
        }
        .user-form_submit {
          margin-top: 20px;
          width: 100%;
        }
      }
    }
  }
}
.el-tooltip__popper {
  width: 215px;
  box-sizing: border-box;
  .user-tooltip {
    padding: 10px 0px 0px 10px;
    .user-tooltip_title {
      font-size: 14px;
      color: #9b9b9b;
    }
    .user-areaList {
      padding: 10px 0px;
      display: flex;
      flex-wrap: wrap;
      .user-areaItem {
        background: #dcdfe6;
        font-size: 14px;
        color: #4a4a4a;
        padding: 4px;
        border-radius: 2px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
.user-dialog {
  .el-dialog__header {
    color: #4a4a4a;
    font-weight: 600;
    font-size: 18px;
  }
  .el-dialog__body {
    padding-top: 6px;
    padding-bottom: 0px;
  }
  .el-dialog__footer {
    padding-top: 0px;
    text-align: left;
    .el-button {
      width: 88px;
    }
  }
}
</style>
